import { takeLatest } from 'redux-saga/effects';
import {
  GlobalActions,
  SOFORTSCHUTZ_AVAILABLE_REQUEST,
  ZAEHLSTUECKEREQUEST,
} from '@ps20-frontend/shop-integration-redux';
import { addTaasLoadingActions } from './addTaasLoadingActions.util';
import { addTaasUpdateAppErrorHandling } from './addTaasUpdateAppErrorHandling';

export const updateAppActionsGenerator = () => {
  return [
    new GlobalActions().updateSofortschutzAvailable(),
    new GlobalActions().updateZaehlstuecke(),
  ];
};

export const updateAppSuccessActions = () => [
  GlobalActions.ZAEHLSTUECKE_RECEIVED,
  GlobalActions.SOFORTSCHUTZ_AVAILABLE,
];

export const updateAppFailActions = () => [
  SOFORTSCHUTZ_AVAILABLE_REQUEST.SOFORTSCHUTZ_AVAILABLE_REQUEST_FAILED,
  ZAEHLSTUECKEREQUEST.ZAEHLSTUECKE_REQUEST_FAILED,
];

export const updateAppAndTarifiere = addTaasLoadingActions(
  addTaasUpdateAppErrorHandling(
    updateAppActionsGenerator,
    updateAppSuccessActions,
    updateAppFailActions,
  ),
);

export function* watchProduktDeleted() {
  yield takeLatest(GlobalActions.PRODUKT_DELETED, updateAppAndTarifiere);
}
